import React from 'react'
const { v4: uuidv4 } = require('uuid')

let __stores = {}

export default props => {
    const { mode, title, children, parm, passUrl } = props

    //다른 layoutMode와 맞춰주기 위한 것.
    const pageId = uuidv4()

    //화면 닫기 처리
    const closePage = () => {
        //여기에 추가로 할 것을 지정
        delete __stores[pageId]
    }

    //저장할 것이 있으면 처리
    const load = () => __stores[pageId]
    const store = pageValue => (__stores[pageId] = pageValue)

    //다른 layoutMode와 맞춰주기 위한 것.
    const setPageExtraInfo = extraInfo => {
        // 이 function 함부로 쓰면 무한 루프 돌 가능성이 있음 아니면 child에서 useEffect에서 사용해야 함.
    }

    return (
        <div className="w-full">
            {React.Children.map(children, child =>
                React.cloneElement(child, {
                    pageId,
                    pageMode: 'new',
                    pageStore: { load, store },
                    setPageExtraInfo,
                    closePage,
                })
            )}
        </div>
    )
}
